import { isDefined, toError } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { isAfter, parseISO, subDays } from "date-fns";

export function isAutoShiftUnassignmentWithinValidityWindow(props: {
  autoShiftUnassignmentAt: string;
  autoShiftUnassignmentValidityWindowInDays?: number;
}) {
  const { autoShiftUnassignmentAt, autoShiftUnassignmentValidityWindowInDays } = props;
  if (!isDefined(autoShiftUnassignmentValidityWindowInDays)) {
    // If this configuration is missing, we will assume that the validity period is unlimited.
    return true;
  }

  try {
    const validityThreshold = subDays(new Date(), autoShiftUnassignmentValidityWindowInDays);
    return isAfter(parseISO(autoShiftUnassignmentAt), validityThreshold);
  } catch (maybeError) {
    const error = toError(maybeError);
    logError(APP_V2_APP_EVENTS.FAILED_TO_CALCULATE_AUTO_UNASSIGNMENT_VALIDITY_WINDOW, {
      error,
      metadata: {
        autoShiftUnassignmentAt,
        autoShiftUnassignmentValidityWindowInDays,
      },
    });
    // If for some reason there is an error, we will assume that the validity period is unlimited
    return true;
  }
}
